import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/app/data-card/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/opt/buildhome/repo/src/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/opt/buildhome/repo/src/components/header.tsx");
